import { render, staticRenderFns } from "./NewsUpdateForm.vue?vue&type=template&id=53edda7f&scoped=true"
import script from "./NewsUpdateForm.vue?vue&type=script&lang=ts"
export * from "./NewsUpdateForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53edda7f",
  null
  
)

export default component.exports